<template functional>
  <div class="control has-icons-left">
    <input
      type="text"
      class="input"
      :class="$options.bindClass(data)"
      v-bind="$options.bindAttrs(data)"
      v-on="$options.bindListeners(listeners)"
      :ref="props.inputRef"
      :value="$options.inUsd(props.value, $options)"
      @input="e => $options.toCent(parent, listeners, e, $options)"
    >
    <span class="icon is-small is-left">
      <i class="fas fa-dollar-sign"></i>
    </span>
  </div>
</template>

<script>
import Base from './control-base'
import { maskCurrency } from '@/lib/mask'
import debounce from 'lodash/debounce'

export default {
  name: 'ControlUsd',
  mixins: [Base],
  mask: IMask.createMask(maskCurrency(false, false)),
  inUsd: (value, options) => {
    if (value === null) return value

    options.mask.resolve(String(value / 100))
    return options.mask.value
  },
  // when input
  toCent: debounce(function(parent, listeners, e, options) {
    const inputValue = e.target.value
    const save = listeners.input || (() => null)

    // when type nothing (blank)
    if (inputValue == null) return ''
    // when type 0
    if (inputValue === '0') {
      save(0)
      return '0'
    }
    if (inputValue === '') {
      save(null)
      return ''
    }
    // when input 2 char with last is dot (on-fly typing)
    const length = inputValue.length
    if (inputValue[length - 1] === '.') {
      return inputValue
    }

    options.mask.resolve(inputValue)

    const usd = options.mask.unmaskedValue
    const cent = Math.round(parseFloat(usd) * 100)
    const normalize = cent != null && !isNaN(cent) ? cent : 0
    save(normalize)
    parent.$emit('validate')

    return (e.target.value = this.inUsd(normalize, options))
  }, 1),
}
</script>

